/**
 * "Artwork is a frontend concern — build the collection URL from `sm_id`" (touchscreen-api.md
 * §Contract limits). Confirmed pattern (Studio/collection API).
 */
export function artworkUrl(smId: string): string {
  return `https://collection.startlemusic.com/api/records/${encodeURIComponent(smId)}/artwork/embed`;
}
